export const drilldownContent = {
  contacted: {
    title: 'Candidates who received a message',
    description:
      'List of candidates who received a message within the selected time period',
  },
  added: {
    title: 'Candidates added to a Flow',
    description:
      'List of candidates added to a Flow in the selected time period',
  },
  sent_first: {
    title: 'Candidates to whom the first message was sent',
    description:
      'List of candidates for whom the initial message was sent in the selected time period',
  },
  sent_followup: {
    title: 'Candidates to whom a follow-up message was sent',
    description:
      'List of candidates for whom a follow up message was sent in the selected time period',
  },
  opened: {
    title: 'Candidates who opened the message',
    description:
      'List of candidates who opened the messages sent to them in the selected time period',
  },
  replied: {
    title: 'Candidates who replied to the message',
    description:
      'List of candidates who responded to the sent message during the selected time period',
  },
  interested: {
    title: 'Candidates marked as interested',
    description:
      'List of candidates marked as interested in the selected time period',
  },

  // ATS Tables
  hired: {
    title: 'Candidates Hired',
    description:
      'List of candidates who were hired in the selected time period',
  },
  offered: {
    title: 'Offers Sent',
    description:
      'List of candidates to whom an offer was sent in the selected time period',
  },
  accepted: {
    title: 'Offers Accepted',
    description:
      'List of candidates who accepted the offer in the selected time period',
  },
};

export const drilldownContentATS = {
  contacted: 'Sent',
  added: 'Added to kula',
  sent_first: '1st Message Sent',
  sent_followup: 'Follow-up Sent',
  opened: 'Opened',
  replied: 'Replied',
  interested: 'Interested',
};

export default drilldownContent;
